import { render, staticRenderFns } from "./woocommerce-api-service-manager.vue?vue&type=template&id=8e9cb0d6"
import script from "./woocommerce-api-service-manager.vue?vue&type=script&lang=js"
export * from "./woocommerce-api-service-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports